import { CategoryTypeEnum } from '@repo/common/enums';
import {
  BookingCountryService,
  BookingShop,
  SlotInterface,
} from '@repo/common/interfaces';
import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

export type WidgetState = {
  modelId?: string;
  storeId?: string;
  categoryType?: CategoryTypeEnum;
  countryService?: BookingCountryService;
  shop?: BookingShop;
  timeSlot?: SlotInterface;
  informations?: {
    description?: string;
  };
  user?: {
    id?: string;
    email?: string;
  };
};

export type WidgetActions = {
  setModelId: (modelId?: string) => void;
  setStoreId: (storeId?: string) => void;
  setCategoryType: (category?: CategoryTypeEnum) => void;
  setCountryService: (countryService?: BookingCountryService) => void;
  setShop: (shop?: BookingShop) => void;
  setTimeSlot: (timeSlot?: SlotInterface) => void;
  setInformations: (informations?: { description?: string }) => void;
  setUser: (userInfo?: { sub: string; email: string }) => void;
  reset: () => void;
};

export type WidgetStore = WidgetState & WidgetActions;

export const defaultInitState: WidgetState = {
  modelId: undefined,
  storeId: undefined,
  categoryType: undefined,
  countryService: undefined,
  shop: undefined,
  timeSlot: undefined,
  informations: undefined,
  user: undefined,
};

export const createWidgetStore = (
  initState: WidgetState = defaultInitState,
) => {
  return createStore<WidgetStore>()(
    persist(
      (set) => ({
        ...initState,
        setModelId: (modelId?: string) =>
          set((state) => ({
            ...state,
            modelId,
          })),
        setStoreId: (storeId?: string) =>
          set((state) => ({
            ...state,
            storeId,
          })),
        setCategoryType: (categoryType?: CategoryTypeEnum) =>
          set((state) => ({
            ...state,
            categoryType,
          })),
        setCountryService: (countryService?: BookingCountryService) =>
          set((state) => ({
            ...state,
            countryService,
          })),
        setShop: (shop?: BookingShop) =>
          set((state) => ({
            ...state,
            shop,
          })),
        setTimeSlot: (timeSlot?: SlotInterface) =>
          set((state) => ({
            ...state,
            timeSlot,
          })),
        setInformations: (informations?: { description?: string }) =>
          set((state) => ({
            ...state,
            informations,
          })),
        setUser: (userInfo?: { sub: string; email: string }) =>
          set((state) => ({
            ...state,
            user: userInfo,
          })),
        reset: () =>
          set((state) => ({
            ...state,
            ...defaultInitState,
          })),
      }),
      {
        name: 'widget-steps-store',
      },
    ),
  );
};
